import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=b70d22ae&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=b70d22ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d22ae",
  null
  
)

export default component.exports